import React from "react";
import PropTypes from "prop-types";
import { addWithoutAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import styles from "./audio-magazine.m.css";
const newTemplates = addWithoutAdsToTemplates("home");
function getAdsWrappedCollectionTemplate(designTemplate, index) {
  if (index === 0) {
    return newTemplates["ebook-slider-card"];
  }
  if (index === 1) {
    return newTemplates["ebook-eight-card"];
  }
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

export class EbookMagazinePage extends React.Component {
  constructor() {
    super();
    this.state = { filter: null, currentIndex: 0, action: false };
    this.iframeWidgetsRef = React.createRef();
    this.pointtableWidgetsRef = React.createRef();
    this.StoryCollectionWidgetsRef = React.createRef();
  }
  componentDidMount() {
    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: this.props });
    PGAD.loadScript();
  }

  render() {
    return (
      <React.Fragment>
        <div className={styles["audio-magazine-main-page"]}>
          <div className={`js-story-main-container ${`${styles["base"]}`}`}>
            <div className={`${styles["audio-magazine-page-container"]} ${styles["digital-ebook"]} container`}>
              <div ref={this.StoryCollectionWidgetsRef} className={`${styles["page-space"]} container`}>
                <h1 className={styles["page-title"]}>Tamil Audio Books</h1>
                <div className={styles["ebook-magazine-header"]}>
                  <div className={styles["ebook-magazine-left-content"]}>
                    <h1 className={styles["ebook-magazine-header_title"]}>
                      எங்கும், எந்த நேரத்திலும், எந்த டிவைசிலும் படிக்க உங்கள் விரல் நுனியில் உலக அப்டேட்ஸ் அனைத்தும்!
                    </h1>
                    <div className={styles["ebook-benefits"]}>
                      <div className={styles["benefits-list"]}>
                        <div className={styles["benefits-card"]}>
                          <div className={styles["benefits-card-image"]}>
                            <img
                              src="https://images.assettype.com/vikatan/2026-02-21/0qzidwju/benefit-one.png"
                              alt=""
                            />
                          </div>
                          <span>8 பிரிமியம் இதழ்கள்</span>
                        </div>
                        <div className={styles["benefits-card"]}>
                          <div className={styles["benefits-card-image"]}>
                            <img
                              src="https://images.assettype.com/vikatan/2026-02-21/8poeieo6/benefit-two.png"
                              alt=""
                            />
                          </div>
                          <span>விகடன் பிரசுரத்தில் 25% தள்ளுபடி</span>
                        </div>
                        <div className={styles["benefits-card"]}>
                          <div className={styles["benefits-card-image"]}>
                            <img
                              src="https://images.assettype.com/vikatan/2026-02-21/a6kcwgpi/benefit-three.png"
                              alt=""
                            />
                          </div>
                          <span>விகடன் பிலோ ஆடியோ புத்தகங்கள்</span>
                        </div>
                        <div className={styles["benefits-card"]}>
                          <div className={styles["benefits-card-image"]}>
                            <img
                              src="https://images.assettype.com/vikatan/2026-02-21/jefire1h/benefit-four.png"
                              alt=""
                            />
                          </div>
                          <span>இதழ்களை PDF வடிவில் வாசிக்கும் வசதி</span>
                        </div>
                        <div className={styles["benefits-card"]}>
                          <div className={styles["benefits-card-image"]}>
                            <img
                              src="https://images.assettype.com/vikatan/2026-02-21/yynpjzcy/benefit-five.png"
                              alt=""
                            />
                          </div>
                          <span>விலம்பரமில்லா வாசிப்பனுபவம்</span>
                        </div>
                        <div className={styles["benefits-card"]}>
                          <div className={styles["benefits-card-image"]}>
                            <img
                              src="https://images.assettype.com/vikatan/2026-02-21/y1gr74af/benefit-six.png"
                              alt=""
                            />
                          </div>
                          <span>விகடன் பொக்கிசங்கள் 2006 முதல்...</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles["ebook-magazine-right-content"]}>
                    <img src="https://images.assettype.com/vikatan/2026-02-21/bbb7frqv/Rightimage.png" alt="" />
                  </div>
                </div>
                <LazyCollection
                  collection={this.props.data.collection}
                  config={this.props.config}
                  collectionTemplates={getAdsWrappedCollectionTemplate}
                  lazyAfter={3}
                  accentColor={"#2f81cd"}
                  pageType={"Audio Magazine"}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

EbookMagazinePage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  }),
  collection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string
      })
    ).isRequired
  }).isRequired
};
